import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes'

import type { KyrgyzstanGalleryRouteState } from 'entities/kyrgyzstan/lib'
import { GalleryWrapper } from 'entities/kyrgyzstan/ui/gallery-wrapper'

const KyrgyzstanOptionDetailGalleryPage = () => {
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const { state } = useLocation()

  const gallery = (state as KyrgyzstanGalleryRouteState | null)?.gallery
  const data = gallery?.realtyId === id ? gallery : null
  const routeState: KyrgyzstanGalleryRouteState | undefined = data
    ? { gallery: data }
    : undefined

  const handleImageClick = (index: number) => {
    if (!id || !routeState) return

    navigate(
      RoutingPaths.kyrgyzstan.optionDetailGalleryImage.path(id, String(index)),
      {
        state: routeState,
      },
    )
  }

  return (
    <GalleryWrapper
      images={data?.images || []}
      title={data?.title || ''}
      isLoading={false}
      error={null}
      onImageClick={handleImageClick}
    />
  )
}

export default KyrgyzstanOptionDetailGalleryPage
